/**
 * React Query keys for the admin area. Every key starts with 'admin' and a
 * domain so mutations can invalidate by prefix, e.g.
 * `queryClient.invalidateQueries({ queryKey: adminKeys.users.all })`.
 */
export const adminKeys = {
  all: ['admin'] as const,
  users: {
    all: ['admin', 'users'] as const,
    list: (filters: Record<string, unknown>) => ['admin', 'users', 'list', filters] as const,
  },
  helpChat: {
    all: ['admin', 'help-chat'] as const,
    logs: (filters: Record<string, unknown>) => ['admin', 'help-chat', 'logs', filters] as const,
    log: (id: string) => ['admin', 'help-chat', 'log', id] as const,
    session: (sessionId: string) => ['admin', 'help-chat', 'session', sessionId] as const,
    stats: (days: number) => ['admin', 'help-chat', 'stats', days] as const,
  },
  security: {
    all: ['admin', 'security'] as const,
    overview: (hours: number) => ['admin', 'security', 'overview', hours] as const,
    events: (filters: Record<string, unknown>) => ['admin', 'security', 'events', filters] as const,
    authEvents: (filters: Record<string, unknown>) => ['admin', 'security', 'auth-events', filters] as const,
    traffic: (scope: Record<string, unknown>, hours: number) =>
      ['admin', 'security', 'traffic', scope, hours] as const,
    blockedIps: ['admin', 'security', 'blocked-ips'] as const,
  },
  dataSources: {
    all: ['admin', 'data-sources'] as const,
    extractors: (hours: number) => ['admin', 'data-sources', 'extractors', hours] as const,
    flags: (filters: Record<string, unknown>) => ['admin', 'data-sources', 'flags', filters] as const,
    creatorRequests: (filters: Record<string, unknown>) =>
      ['admin', 'data-sources', 'creator-requests', filters] as const,
    apiUsage: (days: number) => ['admin', 'data-sources', 'api-usage', days] as const,
    pool: ['admin', 'data-sources', 'pool'] as const,
  },
  alerts: {
    all: ['admin', 'alerts'] as const,
    list: (filters: Record<string, unknown>) => ['admin', 'alerts', 'list', filters] as const,
    unackedCount: ['admin', 'alerts', 'unacked-count'] as const,
  },
  growth: {
    all: ['admin', 'growth'] as const,
    overview: (weeks: number) => ['admin', 'growth', 'overview', weeks] as const,
    accounts: (filters: Record<string, unknown>) => ['admin', 'growth', 'accounts', filters] as const,
  },
};
